import { getJson } from '../client'
import { API } from '../paths'
import { cashiersSchema, columnsSchema, type Cashiers, type Columns } from '../schemas/station'

/** Реальные эндпоинты AZS API: текущее состояние площадки (ТЗ п. 3.3, период не учитывают). */
export const stationApi = {
  getColumns: (): Promise<Columns> => getJson(API.columns, columnsSchema),
  getCashiers: (): Promise<Cashiers> => getJson(API.cashiers, cashiersSchema),
}
